module.exports = __webpack_public_path__ + "media/images/btn_google_play-25849a356dd1ca4b0b622ba3f34c6eee.png";